import { useContext, useState } from 'react';
import { Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import { useRef } from 'react';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const CreditReport = () => {
	const { getCreditReport, creditReport, creditReportLoad, getDate, getBill, setViewBillModal, downloadExcel } = useContext(AppContext);
	const [filename, setFilename] = useState('report_credit');
	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		if (start !== "" && end !== "") {
			getCreditReport(start, end, staff);
			setFilename(`report_credit_from_${start}_to_${end}`);
		}
	}
	const tableRef = useRef(null);
	const formatExcel = () => {
		if (creditReport !== undefined && creditReport.bills !== undefined && Object.keys(creditReport.bills).length > 0) {
			let data = [];
			Object.keys(creditReport.bills).map(item => {
				data.push({
					'Date': creditReport.bills[item].bill_date,
					'Time': creditReport.bills[item].bill_time,
					'Invoice': creditReport.bills[item].bill_id,
					'Created by': creditReport.bills[item].created_by,
					'Customer': creditReport.bills[item].customer_name,
					'Customer Phone': creditReport.bills[item].customer_phone,
					'Settled by': creditReport.bills[item].settle_by ?? '',
					'Settled at': creditReport.bills[item].settle_date !== null ? creditReport.bills[item].settle_date + ', ' + creditReport.bills[item].settle_time : '',
					'Payment Status': creditReport.bills[item].credit_status ? 'Paid' : 'Pending',
					'Pending Amount': !creditReport.bills[item].credit_status ? creditReport.bills[item].credit_amount : 0,
					'Paid Amount': creditReport.bills[item].credit_status ? creditReport.bills[item].credit_amount : 0,
				});
			});
			return data;
		}
	}
	return (
		<div className='container-fluid'>
			<div className='bgp grid4by6 align-items-center justify-content-between p-2 br-3 mb-2'>
				<div className="d-grid px-2">
					{
						creditReportLoad ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						) : (
							<span className='text-white ' >Credit report</span>
						)
					}
				</div>
				<Form onSubmit={getReport} >
					<Row className="d-flex" >
						<Col xs={12} sm={4} md={3} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									creditReport !== undefined ? (
										creditReport.users !== undefined ? (
											Object.keys(creditReport.users).length > 0 ? (
												Object.keys(creditReport.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{creditReport.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				creditReport !== undefined && creditReport.bills !== undefined && Object.keys(creditReport.bills).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), `${filename}.xlsx`);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							$('.view-bill-link').addClass('hide');
							generatePDF(tableRef, { filename: `${filename}.pdf` });
							$('.view-bill-link').removeClass('hide');
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
							onBeforeGetContent={() => {
								return new Promise((resolve) => {
									$('.view-bill-link').addClass('hide');
									resolve();
								});
							}}
							onAfterPrint={() => {
								$('.view-bill-link').removeClass('hide');
							}}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				{

					creditReport !== undefined ? (
						creditReport.bills !== undefined ? (

							<Table bordered className="tbl-bg-blue" >
								<thead>
									<tr>
										<th>Invoice</th>
										<th>Customer</th>
										<th>Staff</th>
										<th className="text-end" >Payment</th>
										<th className="text-end" >Payment methods</th>
										<th className="text-end" >Credit</th>
									</tr>
								</thead>
								<tbody>
									{
										Object.keys(creditReport.bills).map((cred, cr_i) => (
											<tr key={`cred_${cr_i}`} >
												<td>
													<div className='d-grid'>
														<div className='d-flex'>
															<span onClick={() => {
																getBill(creditReport.bills[cred].bill_id);
																setViewBillModal(true);
															}} className="view-bill-link" ><i className="bi bi-receipt"></i> Bill</span>
														</div>
														<span className="tp2" >Invoice : {creditReport.bills[cred].bill_id}</span>
														<span className="tp2 f14" >{creditReport.bills[cred].bill_date}, {creditReport.bills[cred].bill_time}</span>
													</div>
												</td>
												<td>
													<div className='d-grid'>
														<span className="tp2" >{creditReport.bills[cred].customer_name}</span>
														<span className="tp2 f14" >{creditReport.bills[cred].customer_phone}</span>
													</div>
												</td>
												<td><span className="tp2" >{creditReport.bills[cred].created_by}</span></td>
												<td>
													{
														creditReport.bills[cred].credit_status ? (
															<>
																<div className="grid8by2 align-items-center justify-content-between  bdrb2 mb-1 px-1">
																	<span className="tp2 " >Payment status</span>
																	<div className='d-flex align-items-center justify-content-end' >
																		<span className="sucess-tag"><i className="bi bi-check-circle"></i> Paid</span>
																	</div>
																</div>
																<div className="grid8by2 align-items-center justify-content-between  bdrb2 mb-1 px-1">
																	<span className="tp2 " >Settle by</span>
																	<div className='d-flex align-items-center justify-content-end' >
																		<span className="tp2 " >{creditReport.bills[cred].settle_by}</span>
																	</div>
																</div>
																<div className="grid8by2 align-items-center justify-content-between  bdrb2 mb-1 px-1">
																	<span className="tp2 " >Settle date</span>
																	<div className='d-flex align-items-center justify-content-end' >
																		<span className="tp2 " >{creditReport.bills[cred].settle_date}</span>
																	</div>
																</div>
																<div className="grid8by2 align-items-center justify-content-between  bdrb2 mb-1 px-1">
																	<span className="tp2 " >Settle time</span>
																	<div className='d-flex align-items-center justify-content-end' >
																		<span className="tp2 " >{creditReport.bills[cred].settle_time}</span>
																	</div>
																</div>
															</>
														) : (
															<div className="grid8by2 align-items-center justify-content-between  px-1">
																<span className="tp2 " >Payment status</span>
																<div className='d-flex align-items-center justify-content-end' >
																	<span className="error-message"><i className="bi bi-x-circle"></i> Pending</span>
																</div>
															</div>
														)
													}
												</td>
												<td>
													<div className="d-grid">
														{
															creditReport.bills[cred].debits_payments !== undefined ? (
																Object.keys(creditReport.bills[cred].debits_payments).length > 0 ? (
																	Object.keys(creditReport.bills[cred].debits_payments).map((b_pay, b_pay_i) => (
																		<div className="grid8by2 align-items-center justify-content-between" key={`bpay_${b_pay_i}`} >
																			<span className="tp2 " >{creditReport.bills[cred].debits_payments[b_pay].name} : </span>
																			<div className='d-flex align-items-center justify-content-end' >
																				<span className="tp2 " >{parseFloat(creditReport.bills[cred].debits_payments[b_pay].amount).toFixed(2)}</span>
																			</div>
																		</div>
																	))
																) : ''
															) : ''
														}
													</div>
												</td>
												<td className="text-end tp2" >{parseFloat(creditReport.bills[cred].credit_amount).toFixed(2)}</td>
											</tr>
										))
									}
									<tr>
										<td colSpan={5} className="text-end bgy" ><span className='f20' >Total</span></td>
										<td className="text-end bgy" ><span className='f20' >{parseFloat(creditReport.credit_total).toFixed(2)}</span></td>
									</tr>
								</tbody>
							</Table>

						) : 'Nothing found!'
					) : ''
				}
			</div>
		</div>
	)
}